export default "__VITE_ASSET__BEt8C7N9__"